import { PATH_HOME, PATH_SIGNUP } from "@routes/paths";
import AuthQuote from "@components/auth/auth.quote";
import AuthLogo from "@components/auth/auth.logo";
import AuthTitle from "@components/auth/auth.title";
import { Link } from "react-router-dom";
import LoginForm from "./login.form";
import { useAppDispatch, useAppSelector } from "@/hooks/redux-hooks";
import { Navigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { setAuthProvider, setAuthToken, setRefreshToken } from "@/utils/axios-instance";
import { getProfile, initializeApp } from "@/store/reducers/auth.reducer";

const LoginContainer = () => {
  const dispatch = useAppDispatch();
  const { isLoggedIn } = useAppSelector((s) => s.auth);
  const [searchParams] = useSearchParams();

  // check if access_token param is defined in the URL
  const access_token = searchParams.get("access_token");
  const refresh_token = searchParams.get("refresh_token");
  const auth_provider = searchParams.get("auth_provider");
  // Get the redirect URL from query parameters
  const redirectUrl = searchParams.get("redirect");

  useEffect(() => {
    if (access_token && refresh_token && auth_provider) {
      setAuthToken(access_token);
      setRefreshToken(refresh_token);
      setAuthProvider(auth_provider);
      dispatch(initializeApp());
      dispatch(getProfile());
    }
  }, [access_token, refresh_token, auth_provider, dispatch]);

  // After successful login, redirect to the original URL or home
  if (isLoggedIn) {
    const targetUrl = redirectUrl ? decodeURIComponent(redirectUrl) : PATH_HOME;
    return <Navigate to={targetUrl} replace />;
  }
  return (
    <div className="grid lg:grid-cols-2 min-h-screen">
      <div className="w-full h-full bg-gray-100 p-10 lg:p-20">
        <div className="mx-auto max-w-sm">
          <AuthLogo />
          <AuthTitle />
          <LoginForm />
          <p className="text-sm text-gray-900 text-center">
            Don't have an account? Let's{" "}
            <Link to={PATH_SIGNUP} className="text-black hover:underline">
              Register
            </Link>
          </p>
        </div>
      </div>
      <AuthQuote />
    </div>
  );
};

export default LoginContainer;
